export const DEFAULT_ETH_NODE = 'wss://mainnet.eth.aragon.network/ws'
export const DEFAULT_CURRENCY = {
  name: 'Ether',
  symbol: 'ETH',
  decimals: 18
}
